module.exports = __webpack_public_path__ + "images/emoji/factory.51f9a317a1c141bd1dc2.png";